import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header my-3 border-0 align-items-center" }
const _hoisted_3 = { class: "card-title m-0 mx-5 text-center" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "card-title m-0 mx-5 text-center" }
const _hoisted_6 = { class: "fw-bolder m-0" }
const _hoisted_7 = { class: "card-title m-0 mx-5 text-center" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-lg-8 fv-row fv-plugins-icon-container" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "ms-3" }
const _hoisted_13 = { class: "ms-auto me-5" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["title"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "card" }
const _hoisted_19 = { class: "card-body py-3" }
const _hoisted_20 = {
  key: 0,
  class: "bi bi-check-circle-fill fs-3 text-success"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-question-circle-fill text-muted ms-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_download_excel = _resolveComponent("download-excel")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.solicitud?.entidadesSolicitudInformacionExterna.length), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("tabla.organismo.envios")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, [
            _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.respuestas), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("tabla.organismo.respuestas")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.admiteRespuestas,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.admiteRespuestas) = $event)),
                class: "ml-2 mt-2",
                value: _ctx.solicitud?.admiteRespuestas,
                onClick: _ctx.cambiarEstadoAdmision
              }, null, 8, ["modelValue", "value", "onClick"]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_ErrorMessage, { name: "admiteRespuestas" })
                ])
              ])
            ])
          ]),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("tabla.organismo.admiteRespuestas")), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sincronizarConHub && _ctx.sincronizarConHub(...args))),
            disabled: !_ctx.respuestas,
            type: "button",
            class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary w-100 mx-3",
            "data-kt-menu-trigger": "click",
            "data-kt-menu-placement": "bottom-end",
            "data-kt-menu-flip": "top-end"
          }, [
            _createElementVNode("i", {
              class: "fas fa-sync fs-3 mx-2",
              title: _ctx.$t('tabla.respuestas.boton.descargar')
            }, null, 8, _hoisted_15),
            _createTextVNode(_toDisplayString(_ctx.$t("tabla.organismo.sincronizarHub")), 1)
          ], 8, _hoisted_14)
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_download_excel, {
            data: _ctx.respuestasFormularios,
            name: _ctx.csvName,
            labels: _ctx.csvLabels
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                disabled: !_ctx.respuestas,
                type: "button",
                class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary w-100 mx-3",
                "data-kt-menu-trigger": "click",
                "data-kt-menu-placement": "bottom-end",
                "data-kt-menu-flip": "top-end"
              }, [
                _createElementVNode("i", {
                  class: "fas fa-file-excel fs-3 mx-2",
                  title: _ctx.$t('tabla.respuestas.boton.descargar')
                }, null, 8, _hoisted_17),
                _createTextVNode(_toDisplayString(_ctx.$t("tabla.organismo.descargarRespuestas")), 1)
              ], 8, _hoisted_16)
            ]),
            _: 1
          }, 8, ["data", "name", "labels"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _ctx.entidad,
          style: {"width":"100%"},
          stripe: "",
          "default-sort": { prop: 'createdOn', order: 'descending' },
          onSortChange: _ctx.sortChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('tabla.organismo.cabecera.nombre'),
              prop: "comarcaNombre",
              sortable: "",
              "min-width": "150"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('tabla.organismo.cabecera.correo'),
              prop: "comarcaEmail",
              sortable: "",
              "min-width": "150"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('tabla.organismo.cabecera.tipoOrganismo'),
              prop: "tipoOrganizacionNombre",
              sortable: "",
              "min-width": "100"
            }, null, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              "min-width": "80",
              fixed: "right",
              label: _ctx.$t('tabla.organismo.cabecera.respuesta'),
              align: "right"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, [
                  (scope.row.respondido === 'true')
                    ? (_openBlock(), _createElementBlock("i", _hoisted_20))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        onClick: ($event: any) => (_ctx.reenviarCorreo(scope.$index, scope.row)),
                        class: _normalizeClass(
                  _ctx.solicitud?.admiteRespuestas === false
                    ? 'text-muted'
                    : 'text-primary'
                ),
                        style: {"cursor":"pointer"}
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t("tabla.organismo.reenviar")) + " ", 1),
                        (_ctx.solicitud?.admiteRespuestas === false)
                          ? (_openBlock(), _createBlock(_component_el_tooltip, {
                              key: 0,
                              content: _ctx.$t('tabla.organismo.tooltip')
                            }, {
                              default: _withCtx(() => [
                                _hoisted_22
                              ]),
                              _: 1
                            }, 8, ["content"]))
                          : _createCommentVNode("", true)
                      ], 10, _hoisted_21))
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              width: "50",
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                (scope.row.respondido === 'true')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      size: "small",
                      type: "text",
                      onClick: ($event: any) => (_ctx.handleEdit(scope.$index, scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("tabla.profesionalesListado.fila.ver")), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "onSortChange"])), [
          [_directive_loading, _ctx.cargaListado]
        ]),
        _createVNode(_component_el_pagination, {
          class: "my-5 float-end",
          background: "",
          "page-size": 100,
          layout: "prev, pager, next",
          total: _ctx.solicitud?.entidadesSolicitudInformacionExterna.length,
          "hide-on-single-page": true,
          "current-page": _ctx.currentPage,
          onCurrentChange: _ctx.handleCurrentPageChange
        }, null, 8, ["total", "current-page", "onCurrentChange"])
      ])
    ])
  ], 64))
}